//common
import './common';
import { Carousel } from './blocks/carousel';
import { EffectFade, Pagination, Navigation } from 'swiper';
import './blocks/media';
import collapse from './blocks/collapse';

new class extends Carousel{
    getClasses() {
        return {
            ...super.getClasses(),
            carousel: 'milk-why-tabs-tabs',
        }
    }

    getSettings(item) {
        return {
            ...super.getSettings(item),
            effect: 'fade',
            ...item.dataset,
            simulateTouch: false,
            autoHeight: true,
        }
    }

    initItem(el) {
        const {item, swiper} = super.initItem(el);
        item.closest('.milk-why-tabs').addEventListener('click', e => {
            const button = e.target.closest('.milk-why-tab-button');
            if (button) {
                e.currentTarget.querySelector('.milk-why-tab-buttons .active').classList.remove('active');
                button.classList.add('active');
                swiper.slideTo(button.dataset.slide - 1);
            }
        })
    }

    getModules() {
        return [EffectFade]
    }
}
new class extends Carousel{
    getClasses() {
        return {
            ...super.getClasses(),
            carousel: 'milk-why-about-milk',
            buttonNext: 'next',
            buttonPrev: 'prev',
        }
    }

    getSettings(item) {
        const settings = {
            ...super.getSettings(item),
            initialSlide: +item.dataset.initialSlide,
            effect: 'fade',
            simulateTouch: false,
            autoHeight: true,
            loop: true,
            navigation: {
                nextEl: `.${this.classes.carousel} .${this.classes.buttonNext}`,
                prevEl: `.${this.classes.carousel} .${this.classes.buttonPrev}`,
            },
        }
        return  settings;
    }

    initItem(el) {
        const {item, swiper} = super.initItem(el);
        item.addEventListener('click', e => {
            const button = e.target.closest('.milk-why-about-milk-button');
            if (button) {
                swiper.slideTo(button.dataset.slide);
            }
        })
    }

    getModules() {
        return [EffectFade, Navigation]
    }
}

new class extends Carousel{
    getClasses() {
        return {
            ...super.getClasses(),
            carousel: 'milk-can-drink',
            buttonNext: 'next',
            buttonPrev: 'prev',
        }
    }

    getSettings(item) {
        const settings = {
            ...super.getSettings(item),
            effect: 'fade',
            simulateTouch: false,
            autoHeight: true,
            loop: true,
            navigation: {
                nextEl: `.${this.classes.carousel} .${this.classes.buttonNext}`,
                prevEl: `.${this.classes.carousel} .${this.classes.buttonPrev}`,
            },
            pagination: {
                el: `.${this.classes.pagination}`,
                clickable: true,
            },
        }
        return  settings;
    }

    getModules() {
        return [EffectFade, Navigation, Pagination]
    }
}


new class extends Carousel{
    getClasses() {
        return {
            ...super.getClasses(),
            carousel: 'milk-quality-cards',
            carouselWrap: 'milk-quality-cards-wrap',
            buttonNext: 'next',
            buttonPrev: 'prev',
        }
    }

    getSettings(item) {
        const settings = {
            ...super.getSettings(item),
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 16,
        }
        return  settings;
    }

    getModules() {
        return [EffectFade, Navigation]
    }
}

new class extends Carousel{
    getClasses() {
        return {
            ...super.getClasses(),
            carousel: 'milk-test',
        }
    }

    getSettings(item) {
        const settings = {
            ...super.getSettings(item),
            slidesPerView: 1,
            spaceBetween: 16,
            effect: 'fade',
            simulateTouch: false,
            autoHeight: true,
            allowTouchMove: false,
        }
        return  settings;
    }

    initItem(el) {
        const {item, swiper} = super.initItem(el);
        item.addEventListener('click', e => {
            const button = e.target.closest('.milk-test-button');
            if (button) {
                button.classList.add('_clicked');
                if (
                    swiper.realIndex >= swiper.slides.length - 2 &&
                    item.querySelectorAll('._clicked._true').length >= item.dataset.correctCount
                ) {
                    item.classList.add('correct')
                } 
                swiper.slideTo(swiper.realIndex + 1);
            }
        })
    }

    getModules() {
        return [EffectFade]
    }
}

new class extends Carousel{
    getClasses() {
        return {
            ...super.getClasses(),
            carousel: 'milk-articles',
        }
    }

    getSettings(item) {
        const settings = {
            ...super.getSettings(item),
            slidesPerView: 'auto',
            spaceBetween: 16,
        }
        return  settings;
    }

}

document.addEventListener('oncollapse', onCollapseExpand);
document.addEventListener('onexpand', onCollapseExpand);

function onCollapseExpand(e) {
    const question = e.target.closest('.milk-question');
    if (question) {
        if (e.target.classList.contains('_active')) {
            question.classList.remove('milk-question-active');
        } else {
            document.querySelectorAll('.milk-question-active ._collapse-header._active').forEach(header => {
                collapse.hide(header);
            })
            question.classList.add('milk-question-active')
        }
    }
}
